import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { QRCode } from 'lifetaggerQrCode';
import uuid from 'react-uuid';
import Parse from 'parse';
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import Upload from '../ui/upload.component';
import { All as UCIndex } from '../userconnectors/userconnector.container';
import { All as ConnectorIndex } from '../connectors/connector.container';
import { fetchConnectorAction } from '../connectors/connector.actions';
import { Slider } from '@mui/material';
import { createLifeCodeSignal } from '../api/lifetaggerApi';
import './LifeCodeCreationWorkspace.css';

const mySavedParams = {};

const CreateQrCode = (props) => {
  const [beaconId] = useState(uuid().toUpperCase());
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type] = useState('qrcode');
  const [image, setImage] = useState('/images/Layer_2@3x.png');
  const [fgColor, setFgColor] = useState('#262626');
  const [bgColor, setBgColor] = useState('#f2f2f2');
  const [qrStyle, setQrStyle] = useState('dots');
  const [shortenedUrl, setShortenedUrl] = useState('');
  const [followButtonText, setFollowButtonText] = useState('Follow');
  const [followButtonFields, setFollowButtonFields] = useState([]);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [activeConnector, setActiveConnector] = useState(null);
  const [activeStep, setActiveStep] = useState('connect');
  const connectors = useSelector((state) => state.connector?.data);
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [dataBases, setDatabases] = useState([]);
  const [dataBase, setDataBase] = useState(null);
  const [eyeRadius, setEyeRadius] = useState(0);
  const [currentStepParams, setCurrentStepParams] = useState([]);
  const [pageStep, setPageStep] = useState(0);
  const [draftDirty, setDraftDirty] = useState(false);
  const [leaveOpen, setLeaveOpen] = useState(false);
  const [imageUrlOpen, setImageUrlOpen] = useState(false);
  const [fieldDraft, setFieldDraft] = useState({
    name: '',
    label: '',
    description: '',
  });
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState('');
  const [createdSignal, setCreatedSignal] = useState(null);
  //const [savedParams, setSavedParams] = useState({});

  useEffect(() => {
    const fetchUrl = async () => {
      const longUrl = `${process.env.REACT_APP_URL}/experience/lifecode/${beaconId}`;
      setShortenedUrl(longUrl);
      try {
        const apiUrl = `https://api.tinyurl.com/create?api_token=${process.env.REACT_APP_TINY_URL_API_KEY}`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ url: longUrl }),
        });
        if (!response.ok) return;
        const result = await response.json();
        if (result.data?.tiny_url) setShortenedUrl(result.data.tiny_url);
      } catch {
        // The dynamic LifeTagger URL remains valid when shortening is unavailable.
      }
    };

    fetchUrl();
  }, [beaconId]);

  const handleFileUpload = async (files) => {
    let parseImage = new Parse.File('image', files[0], files[0].type);
    await parseImage.save();
    setImage(parseImage.url());
    setDraftDirty(true);
  };

  const handleDatabaseChange = (event) => {
    const selected = dataBases[Number(event.target.value)];
    setDataBase(selected || null);
    setDraftDirty(true);
  };

  const removeField = (id) => {
    // remove field on followButtonFields with the sent in id
    const newFollowButtonFields = removeObjectById(followButtonFields, id);
    setFollowButtonFields(newFollowButtonFields);
  };

  function removeObjectById(array, idToRemove) {
    return array.filter((obj) => obj.id !== idToRemove);
  }

  const handleTableChange = (event) => {
    const selected = tables[Number(event.target.value)];
    setSelectedTable(selected || null);
    setDraftDirty(true);
  };

  useEffect(() => {
    if (dataBase) {
      const getNextAction = activeConnector.actions?.find(
        (action) => action.step === activeStep
      );
      //const newSavedParams = Object.assign({}, savedParams);

      for (let i = 0; i < currentStepParams.length; i++) {
        const textReplace = dataBase[currentStepParams[i]];
        if (textReplace) mySavedParams[currentStepParams[i]] = textReplace;
        const replaceWith = currentStepParams[i];
        const regex = new RegExp(`{(${replaceWith})}`, 'g');
        getNextAction.path = getNextAction.path.replace(regex, textReplace);
      }
      //setSavedParams(newSavedParams);

      if (getNextAction.next) {
        if (getNextAction.next.params) {
          setCurrentStepParams(getNextAction.next.params);
        }
        setActiveStep(getNextAction.next.step);
      }
      getNextAction.params = { id: getNextAction.step };

      dispatch(fetchConnectorAction(getNextAction));
    }
  }, [dataBase]);

  useEffect(() => {
    if (selectedTable) {
      const getNextAction = activeConnector.actions?.find(
        (action) => action.step === activeStep
      );

      //const newSavedParams = Object.assign({}, savedParams);

      for (let i = 0; i < currentStepParams.length; i++) {
        let textReplace = selectedTable[currentStepParams[i]];

        if (textReplace === undefined) {
          textReplace = mySavedParams[currentStepParams[i]];
        }

        if (textReplace) mySavedParams[currentStepParams[i]] = textReplace;
        const replaceWith = currentStepParams[i];
        const regex = new RegExp(`{(${replaceWith})}`, 'g');
        getNextAction.path = getNextAction.path.replace(regex, textReplace);
      }
      //setSavedParams(newSavedParams);

      // for loop to replace getNextAction.path which has strings that should be replaced when they have this form {someString} find the

      if (getNextAction.next) {
        if (getNextAction.next.params) {
          setCurrentStepParams(getNextAction.next.params);
        }
        setActiveStep(getNextAction.next.step);
      }

      if (selectedTable.fields) {
        handleFields(selectedTable);
      } else {
        dispatch(fetchConnectorAction(getNextAction));
      }
    }
  }, [selectedTable]);

  // useEffect(() => {
  //   const getNextAction = activeConnector.actions?.find(
  //     (action) => action.step === activeStep
  //   );

  //   if (getNextAction) {
  //     dispatch(fetchConnectorAction(getNextAction));
  //     if (getNextAction.next) {
  //       console.log(getNextAction.next.step);
  //       if (getNextAction.next.params) {
  //         setCurrentStepParams(getNextAction.next.params);
  //       }
  //       setActiveStep(getNextAction.next.step);
  //     }
  //   }
  // }, [tables]);

  useEffect(() => {
    const connector = connectors?.find((b) => b.id === activeConnector?.id);
    if (connector) {
      setActiveConnector(connector);
    }

    if (connector?.actionData) {
      if (activeStep === 'connectTable') {
        setDatabases(connector.actionData);
      }
      if (activeStep === 'connectFields') {
        setTables(connector.actionData);
      }
    }
  }, [connectors]);

  const handleConnectorActionClick = (action, id) => {
    const connector = connectors.find((b) => b.id === id);

    setActiveConnector(connector);
    if (action.next) {
      if (action.next.params) {
        setCurrentStepParams(action.next.params);
      }
      setActiveStep(action.next.step);
    }

    dispatch(fetchConnectorAction(action));
  };

  const handleFields = (table) => {
    const newFollowButtonFields = JSON.parse(
      JSON.stringify(followButtonFields)
    );

    const getActionButtonStep = activeConnector.actions?.find(
      (action) => action.step === 'connectButton'
    );

    for (let i = 0; i < getActionButtonStep.params?.length; i++) {
      let textReplace = mySavedParams[getActionButtonStep.params[i]];
      const replaceWith = currentStepParams[i];
      const regex = new RegExp(`{(${replaceWith})}`, 'g');
      getActionButtonStep.path = getActionButtonStep.path.replace(
        regex,
        textReplace
      );
    }

    for (let i = 0; i < table.fields.length; i++) {
      let field = table.fields[i];
      newFollowButtonFields.push({
        id: field.id,
        label: field.name,
        name: field.name,
        tableId: table.id,
        action: getActionButtonStep.path || null,
        method: getActionButtonStep.method || null,
      });
    }

    setFollowButtonFields(removeDuplicates(newFollowButtonFields));
  };

  function removeDuplicates(array) {
    const seenIds = new Set();
    return array.filter((obj) => {
      if (seenIds.has(obj.id)) {
        return false; // Skip objects with duplicate IDs
      } else {
        seenIds.add(obj.id);
        return true;
      }
    });
  }

  const saveBeacon = async () => {
    const lifeCodeInput = {
      beaconId,
      name,
      description,
      type,
      image,
      fgColor,
      bgColor,
      qrStyle,
      shortenedUrl,
      followButtonFields,
      followButtonText,
      eyeRadius,
    };
    setSaving(true);
    setSaveError('');
    try {
      const created = await createLifeCodeSignal(lifeCodeInput);
      setCreatedSignal(created);
      setDraftDirty(false);
    } catch (error) {
      setSaveError(error.message || 'The LifeCode could not be created.');
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const warnBeforeLeaving = (event) => {
      if (!draftDirty) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warnBeforeLeaving);
    return () => window.removeEventListener('beforeunload', warnBeforeLeaving);
  }, [draftDirty]);

  const steps = [
    'Name',
    'Design',
    'Follow experience',
    'Integrations',
    'Review',
  ];

  const updateDraft = (setter) => (event) => {
    setter(event.target.value);
    setDraftDirty(true);
  };

  const goToStep = (nextStep) => {
    setPageStep(Math.max(0, Math.min(steps.length - 1, nextStep)));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const requestCancel = () => {
    if (draftDirty) setLeaveOpen(true);
    else if (props.handleClose) props.handleClose();
    else if (props.history) props.history.push('/signals');
  };

  const addVisitorField = () => {
    if (!fieldDraft.name.trim() || !fieldDraft.label.trim()) return;
    setFollowButtonFields([
      ...followButtonFields,
      {
        id: `visitor-${Date.now()}`,
        name: fieldDraft.name.trim(),
        label: fieldDraft.label.trim(),
        description: fieldDraft.description.trim(),
      },
    ]);
    setFieldDraft({ name: '', label: '', description: '' });
    setOpen(false);
    setDraftDirty(true);
  };

  const renderStep = () => {
    if (createdSignal) {
      return (
        <>
          <div className="lc-create__created-banner">
            ✓ {name} was created. Its dynamic scan address is active.
          </div>
          <header className="lc-create__heading">
            <span>Signals / {name}</span>
            <h1>{name}</h1>
            <p>LifeCode · Active · Created just now</p>
          </header>
          <section className="lc-create__card">
            <h2>Dynamic from the first scan</h2>
            <p>
              Any phone camera can scan this LifeCode. Change its connected
              content and follow experience without replacing the printed code.
            </p>
          </section>
          <section className="lc-create__card lc-create__review">
            <h2>Follow experience</h2>
            <div>
              <small>Button</small>
              <strong>{followButtonText}</strong>
            </div>
            <div>
              <small>Visitor fields</small>
              <strong>
                {followButtonFields.map((field) => field.name).join(' · ') ||
                  'None'}
              </strong>
            </div>
          </section>
          <div className="lc-create__created-actions">
            <button
              className="lc-button lc-button--secondary"
              type="button"
              onClick={() => window.print()}
            >
              Print LifeCode
            </button>
            <button
              className="lc-button lc-button--primary"
              type="button"
              onClick={() => props.history?.push('/signals')}
            >
              Manage in Signals
            </button>
          </div>
        </>
      );
    }
    if (pageStep === 0) {
      return (
        <>
          <header className="lc-create__heading">
            <span>Signals / New signal / LifeCode</span>
            <h1>Name your LifeCode</h1>
            <p>
              Give your team a clear name and useful context. Its code and
              dynamic scan address are generated securely when it is created.
            </p>
          </header>
          <section className="lc-create__card">
            <label>
              <strong>LifeCode name</strong>
              <input
                autoFocus
                value={name}
                onChange={updateDraft(setName)}
                placeholder="Garden Welcome"
              />
              <small>Use a name your team will recognize.</small>
            </label>
            <label>
              <strong>Description</strong>
              <textarea
                value={description}
                onChange={updateDraft(setDescription)}
                placeholder="Where this LifeCode will be used"
              />
              <small>Optional. This is for collaborators, not visitors.</small>
            </label>
            <div className="lc-create__notice lc-create__notice--success">
              <span aria-hidden="true">↻</span>
              Dynamic by default — update the connected experience later without
              reprinting the LifeCode.
            </div>
          </section>
        </>
      );
    }

    if (pageStep === 1) {
      return (
        <>
          <header className="lc-create__heading">
            <span>Signals / New LifeCode / Design</span>
            <h1>Make it recognizable</h1>
            <p>
              Fine-tune the code while scan-safe constraints stay protected.
              Every change appears in the live preview.
            </p>
          </header>
          <section className="lc-create__card">
            <h2>Center image</h2>
            <div className="lc-create__inline-actions">
              <Upload
                handleFileUpload={handleFileUpload}
                mediaType={[
                  'image/png',
                  'image/jpeg',
                  'image/jpg',
                  'image/gif',
                ]}
              />
              <button
                className="lc-button lc-button--secondary"
                type="button"
                onClick={() => setImageUrlOpen(!imageUrlOpen)}
              >
                Use image URL
              </button>
              <button
                className="lc-button lc-button--quiet"
                type="button"
                onClick={() => {
                  setImage('');
                  setDraftDirty(true);
                }}
              >
                Remove
              </button>
            </div>
            {imageUrlOpen && (
              <label>
                <strong>Public image address</strong>
                <input
                  value={image}
                  onChange={updateDraft(setImage)}
                  placeholder="https://…"
                />
              </label>
            )}
            <div className="lc-create__design-grid">
              <label>
                <strong>Foreground</strong>
                <div className="lc-create__color-field">
                  <input
                    type="color"
                    value={fgColor}
                    onChange={updateDraft(setFgColor)}
                  />
                  <input value={fgColor} onChange={updateDraft(setFgColor)} />
                </div>
              </label>
              <label>
                <strong>Background</strong>
                <div className="lc-create__color-field">
                  <input
                    type="color"
                    value={bgColor}
                    onChange={updateDraft(setBgColor)}
                  />
                  <input value={bgColor} onChange={updateDraft(setBgColor)} />
                </div>
              </label>
              <label>
                <strong>Pattern style</strong>
                <select value={qrStyle} onChange={updateDraft(setQrStyle)}>
                  <option value="dots">Rounded dots</option>
                  <option value="squares">Squares</option>
                </select>
              </label>
              <label>
                <strong>Corner eye roundness</strong>
                <Slider
                  value={eyeRadius}
                  onChange={(event, value) => {
                    setEyeRadius(value);
                    setDraftDirty(true);
                  }}
                  min={0}
                  max={50}
                  valueLabelDisplay="auto"
                />
              </label>
            </div>
            <small>
              Contrast and logo size should keep the LifeCode easy to scan.
            </small>
          </section>
        </>
      );
    }

    if (pageStep === 2) {
      return (
        <>
          <header className="lc-create__heading">
            <span>Signals / New LifeCode / Follow experience</span>
            <h1>Shape what visitors can do</h1>
            <p>
              Configure the action shown after scanning and the information
              visitors may choose to share.
            </p>
          </header>
          <section className="lc-create__card">
            <label>
              <strong>Button text</strong>
              <input
                value={followButtonText}
                onChange={updateDraft(setFollowButtonText)}
              />
              <small>Previewed exactly as visitors will see it.</small>
            </label>
          </section>
          <section className="lc-create__card">
            <div className="lc-create__section-heading">
              <div>
                <h2>Follow form</h2>
                <small>
                  Drag to reorder. Internal keys are generated automatically.
                </small>
              </div>
              <button
                className="lc-button lc-button--secondary"
                type="button"
                onClick={() => setOpen(true)}
              >
                + Add field
              </button>
            </div>
            {followButtonFields.length === 0 ? (
              <div className="lc-create__empty">
                No visitor fields yet. Add only the information this experience
                needs.
              </div>
            ) : (
              followButtonFields.map((field) => (
                <div className="lc-create__field-row" key={field.id}>
                  <span aria-hidden="true">⋮⋮</span>
                  <div>
                    <strong>{field.name}</strong>
                    <small>{field.label || field.description}</small>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      removeField(field.id);
                      setDraftDirty(true);
                    }}
                  >
                    Remove
                  </button>
                </div>
              ))
            )}
          </section>
        </>
      );
    }

    if (pageStep === 3) {
      return (
        <>
          <header className="lc-create__heading">
            <span>Signals / New LifeCode / Integrations</span>
            <h1>Bring in organization data</h1>
            <p>
              Connect approved tools and map their fields into the visitor form
              without exposing technical layers.
            </p>
          </header>
          <section className="lc-create__card lc-create__integrations">
            <h2>Connected tools</h2>
            <UCIndex step="connect" callBack={handleConnectorActionClick} />
            <h2>Connect a tool</h2>
            <ConnectorIndex step="connect" />
            {activeStep === 'connectTable' && (
              <label>
                <strong>Information source</strong>
                <select
                  value={dataBase ? dataBases.indexOf(dataBase) : ''}
                  onChange={handleDatabaseChange}
                >
                  <option value="" disabled>
                    Choose a source
                  </option>
                  {dataBases.map((source, index) => (
                    <option key={index} value={index}>
                      {source.dataSource}
                    </option>
                  ))}
                </select>
              </label>
            )}
            {dataBase && (
              <label>
                <strong>Collection</strong>
                <select
                  value={selectedTable ? tables.indexOf(selectedTable) : ''}
                  onChange={handleTableChange}
                >
                  <option value="" disabled>
                    Choose a collection
                  </option>
                  {tables.map((table, index) => (
                    <option key={index} value={index}>
                      {table.tableName}
                    </option>
                  ))}
                </select>
              </label>
            )}
          </section>
        </>
      );
    }

    return (
      <>
        <header className="lc-create__heading">
          <span>Signals / New LifeCode / Review</span>
          <h1>Ready to create</h1>
          <p>
            Review the operator setup, visitor experience, and connected data
            before creating the dynamic LifeCode.
          </p>
        </header>
        <section className="lc-create__card lc-create__review">
          <div>
            <small>Name</small>
            <strong>{name || 'Untitled LifeCode'}</strong>
          </div>
          <div>
            <small>Follow experience</small>
            <strong>
              {followButtonText || 'No action configured'} ·{' '}
              {followButtonFields.length} visitor fields
            </strong>
          </div>
          <div>
            <small>Integration</small>
            <strong>
              {activeConnector
                ? activeConnector.name || 'Connected tool'
                : 'None'}
            </strong>
          </div>
        </section>
        <div className="lc-create__notice lc-create__notice--success">
          ↻ Your secure LifeCode identity and dynamic scan address will be
          generated when you create it.
        </div>
        {saveError && (
          <div className="lc-create__notice lc-create__notice--error">
            {saveError} Retry when you’re ready.
          </div>
        )}
      </>
    );
  };

  return (
    <div className="lc-create">
      <div className="lc-create__layout">
        <nav className="lc-create__steps" aria-label="LifeCode creation steps">
          {steps.map((step, index) => (
            <button
              key={step}
              type="button"
              className={
                index === pageStep
                  ? 'is-active'
                  : index < pageStep
                  ? 'is-complete'
                  : ''
              }
              onClick={() => goToStep(index)}
            >
              <span>{index < pageStep ? '✓' : index + 1}</span>
              {step}
            </button>
          ))}
        </nav>
        <main className="lc-create__main">
          {renderStep()}
          {!createdSignal && (
            <footer className="lc-create__footer">
              <button
                type="button"
                className="lc-button lc-button--quiet"
                onClick={requestCancel}
              >
                Cancel
              </button>
              <div>
                {pageStep > 0 && (
                  <button
                    type="button"
                    className="lc-button lc-button--secondary"
                    onClick={() => goToStep(pageStep - 1)}
                  >
                    Back
                  </button>
                )}
                {pageStep < steps.length - 1 ? (
                  <button
                    type="button"
                    className="lc-button lc-button--primary"
                    disabled={pageStep === 0 && !name.trim()}
                    onClick={() => goToStep(pageStep + 1)}
                  >
                    {pageStep === 0
                      ? 'Continue to design'
                      : pageStep === 1
                      ? 'Build follow experience'
                      : pageStep === 2
                      ? 'Connect integrations'
                      : 'Review LifeCode'}{' '}
                    →
                  </button>
                ) : (
                  <button
                    type="button"
                    className="lc-button lc-button--primary"
                    disabled={!name.trim() || saving}
                    onClick={saveBeacon}
                  >
                    {saving ? 'Creating LifeCode…' : 'Create LifeCode'}
                  </button>
                )}
              </div>
            </footer>
          )}
        </main>
        <aside className="lc-create__preview">
          <div className="lc-create__preview-header">
            <span>LIVE LIFECODE</span>
            <small>● Updates live</small>
          </div>
          <div className="lc-create__code-stage">
            <QRCode
              value={
                shortenedUrl ||
                `${process.env.REACT_APP_URL}/experience/lifecode/${beaconId}`
              }
              logoImage={image}
              fgColor={fgColor}
              bgColor={bgColor}
              enableCORS={true}
              logoWidth="35"
              removeQrCodeBehindLogo={true}
              eyeRadius={eyeRadius}
              size="210"
              qrStyle={qrStyle}
            />
          </div>
          <h2>{name || 'Untitled LifeCode'}</h2>
          <p>
            The printed code stays the same while connected content can change.
          </p>
        </aside>
      </div>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Add a visitor field</DialogTitle>
        <DialogContent className="lc-create__dialog">
          <TextField
            required
            margin="dense"
            label="Field name"
            value={fieldDraft.name}
            onChange={(event) =>
              setFieldDraft({ ...fieldDraft, name: event.target.value })
            }
            fullWidth
          />
          <TextField
            required
            margin="dense"
            label="Visitor label"
            value={fieldDraft.label}
            onChange={(event) =>
              setFieldDraft({ ...fieldDraft, label: event.target.value })
            }
            fullWidth
          />
          <TextField
            margin="dense"
            label="Description"
            value={fieldDraft.description}
            onChange={(event) =>
              setFieldDraft({ ...fieldDraft, description: event.target.value })
            }
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={addVisitorField}>Add field</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={leaveOpen} onClose={() => setLeaveOpen(false)}>
        <DialogTitle>Leave LifeCode creation?</DialogTitle>
        <DialogContent>
          Your name, appearance, follow fields, and integration mapping have
          unsaved changes.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLeaveOpen(false)}>Stay and review</Button>
          <Button
            color="error"
            onClick={() => {
              setDraftDirty(false);
              setLeaveOpen(false);
              if (props.handleClose) props.handleClose();
              else if (props.history) props.history.push('/signals');
            }}
          >
            Discard changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CreateQrCode;
